import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";

const options = { role: ROLE.BUSINESS };

const path = "business/stripe";
const dashboardPath = "business/dashboard";

export const ListTransactions = async (params = {}) => {
  const query = new URLSearchParams(params).toString();
  const url = `${path}/list-transactions${query ? `?${query}` : ""}`;
  return await axiosInstance(options).get(url);
};

export const GetDashboard = async () => {
  const path = `${dashboardPath}/dashboard`;
  return await axiosInstance(options).get(path);
};

export const CreateCoupon = async (data) => {
  const path = `${dashboardPath}/create-coupon`;
  return await axiosInstance(options).post(path, data);
};

export const ListCoupons = async (params = {}) => {
  const query = new URLSearchParams(params).toString();
  const url = `${dashboardPath}/coupons/${query ? `?${query}` : ""}`;
  return await axiosInstance(options).get(url);
};

export const deleteCoupon = async (id) => {
  const path = `${dashboardPath}/coupons/${id}`;
  return await axiosInstance(options).delete(path);
};

export const editCoupon = async (data) => {
  const path = `${dashboardPath}/coupons/edit`; // matches backend endpoint
  return await axiosInstance(options).post(path, data);
};

export const getNotifications = async () => {
  const path = `${dashboardPath}/notification-list`;
  return await axiosInstance(options).get(path);
};

export const markNotificationAsSeen = async (notificationId) => {
  const path = `${dashboardPath}/notification-list/mark-as-seen`;
  return await axiosInstance(options).get(path);
};
